import { jsx } from "react/jsx-runtime";
import react, { useCallback, useContext, useMemo } from "react";
import { useSnackbar } from "notistack";
import { getErrorDetails } from "../../utils/getErrorDetails.js";
import { SnackbarContent } from "./SnackbarContent.js";
import { SnackbarErrorContent } from "./SnackbarErrorContent.js";
const SnackbarContext = /*#__PURE__*/ react.createContext(void 0);
function useEnqueueFunction(enqueueSnackbar, severity) {
    return useCallback((message, options)=>enqueueSnackbar(message, {
            preventDuplicate: options?.preventDuplicate ?? true,
            content: (_, message)=>/*#__PURE__*/ jsx(SnackbarContent, {
                    severity: severity,
                    message: message,
                    action: options?.action
                })
        }), [
        enqueueSnackbar,
        severity
    ]);
}
const ErrorToAlertSeverity = {
    error: 'error',
    info: 'info',
    warning: 'warning'
};
function useSnackbarInternal() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const successSnackbar = useEnqueueFunction(enqueueSnackbar, 'success');
    const infoSnackbar = useEnqueueFunction(enqueueSnackbar, 'info');
    const warningSnackbar = useEnqueueFunction(enqueueSnackbar, 'warning');
    const errorSnackbar = useEnqueueFunction(enqueueSnackbar, 'error');
    const exceptionSnackbar = useCallback((error, message, options)=>{
        const errorDetails = getErrorDetails(error, 'string' == typeof message ? {
            severity: 'error',
            title: message
        } : message);
        return enqueueSnackbar(errorDetails.title, {
            persist: true,
            preventDuplicate: options?.preventDuplicate ?? true,
            content: (key)=>/*#__PURE__*/ jsx(SnackbarErrorContent, {
                    id: key,
                    severity: ErrorToAlertSeverity[errorDetails.severity],
                    title: errorDetails.title,
                    subtitle: errorDetails.message,
                    details: errorDetails.serverMessages,
                    closeSnackbar: closeSnackbar
                })
        });
    }, [
        enqueueSnackbar,
        closeSnackbar
    ]);
    const context = useMemo(()=>({
            closeSnackbar,
            errorSnackbar,
            exceptionSnackbar,
            infoSnackbar,
            successSnackbar,
            warningSnackbar
        }), [
        closeSnackbar,
        errorSnackbar,
        exceptionSnackbar,
        infoSnackbar,
        successSnackbar,
        warningSnackbar
    ]);
    return context;
}
function useSnackbar_useSnackbar() {
    const ctx = useContext(SnackbarContext);
    if (void 0 === ctx) throw new Error('No SnackbarContext found. Did you forget the SnackbarProvider?');
    return ctx;
}
export { SnackbarContext, useSnackbar_useSnackbar as useSnackbar, useSnackbarInternal };

//# sourceMappingURL=useSnackbar.js.map